<template>
    <b-row class="animated fadeIn content-col">
         <b-col v-for="(col,index) in columnas" :key="`${idElement}-${index}`" 
          v-bind:class="{ 'column-selected animated pulse infinite': col.selected && !col.element }" 
          class="columna-constructor" 
          variant="primary"
          @click="selectColumn(col,index)">
            <b-col class="text-center btn-add-element" v-if="!col.element" >
                <!--<i class="icon-plus"></i>-->
                <b>Clic Aquí y Seleccione un Elemento de la Barra de Herramientas </b> <font-awesome-icon icon="hand-point-right" size="2x" class="icon-hand-right animated infinite heartBeat color-icon-point" />
            </b-col>
            <component v-else :is="col.element.tag" v-bind="elementPropierties(col.element, index)"></component>
        </b-col>
        <options-element :index-element="idElement" :are-columns="true"></options-element>
    </b-row>
</template>
<script>
// componentes del constructorr
import Parrafo from '@/components/constructor/Parrafo';
import Tabla from '@/components/constructor/Tabla'
import Recurso from '@/components/constructor/Recurso';
import OptionsElement from './OptionsElement';
import QuizContent from './QuizContent';
export default {
    name: 'Columnas',
    components: {
        Parrafo,
        Recurso,
        OptionsElement,
        Tabla,
        QuizContent
    },
    props: {
        columnas:{
            type:Array,
            //default: () => {return new Array({selected: false, element: null},{selected: false, element: null})}
        },
        idElement: {
            type: Number
        }
    },
    data() {
        return {
            //columnas: []
        }
    },
    methods: {
        selectColumn(column, index) {
            if(!column.element) {
                this.columnas.forEach((col,i,array) => {
                    if(col['selected']) col['selected'] = false;
                    if((i+1) == array.length) {
                        column.selected = true;
                        this.$store.dispatch('constructor/selectBlock', { iActivity: this.idElement, iColumn: index });
                    }
                });
            }
        },
        elementPropierties(el, index) {
            let propierties = {};
            switch(el.tag) {
                case 'Parrafo':
                    propierties = {
                        idElement: this.idElement,
                        idColumn: index,
                        content: el.content,
                    }
                    break;
                case 'Tabla':
                    propierties = {
                        idElement: this.idElement,
                        idColumn: index,
                        content: el.content,
                    }
                    break;
                case 'Recurso':
                    propierties = {
                        recursoSelected: el.file,
                        idElement: this.idElement,
                        idColumn: index,
                        tipo: el.type
                    }
                    break;
                 case 'QuizContent':
                    propierties = {
                        preguntas: el.preguntas,
                        desc: el.instrucciones,
                        idElement: this.idElement,
                        idColumn: index
                    }
                    break;
            }
            return propierties;
        },
    }
};
</script>
<style lang="scss">
    .content-col{
        border-style:dashed;
        border-color: #d6d6d6;
        border-width: thin;
        border-radius: .2rem;
        margin: 5px;
    }
    .columna-constructor {
        min-height: 10vh;
        border-right: dashed;
        border-color: #d6d6d6;
        border-width: thin;
        border-radius: .1rem;
        padding: 10px 10px 20px 10px;
        /*margin: auto 0;*/

        .btn-add-element {
            top: 10%;
            margin-bottom: 10px;
            color: #a3a9ad;

            &:hover {
                background: transparent;
                border: solid 1px transparent;
                cursor: pointer;
            }
        }
        &:hover{
            cursor: grab;
        }
    }
    .column-selected {
        background: rgba(77, 189, 116, 0.11);
    }
    .icon-hand-right{
        vertical-align: middle;
        margin-left:20px;  
    }
</style>